import { api } from '@api/api2';
import { AssigneesReplaceByTypesPayload } from '../../models/replace-employee/types/assigneesReplaceByTypesRequest';

const getCountsByTypesForReplaceAssignee = (payload: { assignee_id: string }) =>
  api.v1('get', 'tck/bms/assignees/replace/get-counts-by-types', payload);

const assigneesReplaceByTypes = (payload: AssigneesReplaceByTypesPayload) =>
  api.v1('post', 'tck/bms/assignees/replace/by-types', payload, {
    headers: { 'Content-Type': 'application/json' },
  });

export const replaceEmployee = {
  getCountsByTypesForReplaceAssignee,
  assigneesReplaceByTypes,
};
